<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.5 3V8.5C4.5 10.1569 5.84315 11.5 7.5 11.5L13 11.5M4.5 3L2 5.1875M4.5 3L7 5.1875M13 11.5L10.8125 9M13 11.5L10.8125 14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
